<template>
  <div id="app" class="container">
     <router-view></router-view>
  </div>
</template>

<script>
//const baseUrl = "https://gf-signin-api.luciditv.app";
const baseUrl = "http://127.0.0.1:80808";
export default {
  name: "App",
  components: {},
  data() {
    return {
      isShowInfo: false,
      isSuccess: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      url: null,
      isValidated: null,
      areaOptions:[
        {
          value:"北",
          text:"北區"
        },
        {
          value:"桃",
          text:"桃區"
        },
        {
          value:"竹",
          text:"竹區"
        },
        {
          value:"中",
          text:"中區"
        },
        {
          value:"嘉",
          text:"嘉區"
        },
        {
          value:"南",
          text:"南區"
        },
        {
          value:"園",
          text:"園區"
        },
        {
          value:"高",
          text:"高區"
        },
        {
          value:"海外",
          text:"海外:世界各國"
        },
      ],
      yearOptions:[],
      levelOptions:[
        {value: "春",text:"春"},
        {value: "秋",text:"秋"},
        {value: "增",text:"增"},
        {value: "善",text:"善"},
        {value: "備",text:"備"},
        {value: "宗",text:"宗"}
        ],
      form: {
        region: null,
        name: null,
        lmClassArea: null,
        lmClassYear: null,
        lmClassLevel: null,
        lmClassNo: null,
        lmClassName: null,
        shareLinkCode: null
      }
    };
  },
  computed: {
    computedLmClassName: {
      get: function() {
        if(this.form.lmClassArea == "海外") {
          return `${this.form.lmClassName??''}`;
        }else {
          return `${this.form.lmClassArea??''}${this.form.lmClassYear??''}${this.form.lmClassLevel??''}${this.form.lmClassNo??''}`;
        }
      }
    }
  },
  async created() {
    const maxYear = new Date().getFullYear()-2000;
      for(var i=10;i<=maxYear;i++){
        this.yearOptions.push({value:`${i}`, text:`${i}`});
      }
      /*
      fetch(`${baseUrl}/api/courses`, {
        mode: 'cors',
        method: "GET",
        headers: { "content-type": "application/json" }
      }).then(async res=>{
        const json = await res.json();
        const now = new Date();
        const course = json.find(c=>{
          return new Date(c.startTime) < now && new Date(c.endTime) > now
        })
        if(course){
          this.courseName = course.name
          this.memberCount = course.memberCount
          this.form.courseId = course.id 
        } else {
          this.isShowInfo = true
        }
      })
      this.timer();
      */
  },
  methods: {
    timer() {
      let self = this
      setInterval(() => {
          if(self.form.courseId == null){
            fetch(`${baseUrl}/api/courses`, {
            mode: 'cors',
            method: "GET",
            headers: { "content-type": "application/json" }
            }).then(async res=>{
              const json = await res.json();
              const now = new Date();
              const course = json.find(c=>{
                return new Date(c.startTime) < now && new Date(c.endTime) > now
              })
              if(course){
                self.courseName = course.name
                self.memberCount = course.memberCount
                self.form.courseId = course.id 
                self.isShowInfo = false
              } else {
                self.isShowInfo = true
              }
            })
          }
      }, 30000)
    },
    onDismissed(){
      this.dismissCountDown=0
      if(this.url){
        window.location.href = this.url;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    onPhoneInput(formattedNumber, { number, valid, country }) {
      this.form.phoneNumber = number;
      this.form.phoneCountryCode = country.dialCode;
      this.form.country = country.iso2;
      this.phoneValid = valid;
    },
    async onSignUp() {
      if(!this.form.name || !this.form.lmClassArea){
        this.isValidated = true;
      }
      if(this.form.lmClassArea == '海外') {
        if(!this.form.lmClassName) {
          this.isValidated = true;
        }
      } else {
        if(!this.form.lmClassYear || !this.form.lmClassLevel || !this.form.lmClassNo) {
          this.isValidated = true;
        }
      }
      if(this.isValidated){
        return;
      }
      const res = await fetch(`${baseUrl}/api/record`, {
        mode: 'cors',
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          region: this.form.lmClassArea,
          classname: this.computedLmClassName,
          name: this.form.name,
        }),
      });
      const json = await res.json();
      if (json.code == 200) {
        this.isSuccess = true;
        this.showAlert();
        this.url = json.url;
      }
    },
    async onSignIn() {
      if(!this.form.name || !this.phoneValid){
        this.isValidated = true;
        return;
      }
      const res = await fetch(`${baseUrl}/api/signin`, {
        mode: 'cors',
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(this.form),
      });
      const json = await res.json();
      if (json.code == 200) {
        this.isSuccess = true;
        this.showAlert();
        this.url = json.url;
        //window.location.href = json.url;
      } else if (json.code == 404) {
        this.isSignUpMode = true;
      }
    },
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
